// ═══════════════════════════════════════════════════════════════
// HOOK: useProvisions
// ═══════════════════════════════════════════════════════════════

import { useState, useEffect, useCallback } from 'react';
import { provisionsAPI } from '../api/provisions';

// ── Dashboard / resumen empresa ────────────────────────────────
export function useProvisionsSummary(companyId) {
  const [data, setData]       = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError]     = useState(null);

  const load = useCallback(async () => {
    if (!companyId) return;
    setLoading(true);
    setError(null);
    try {
      setData(await provisionsAPI.getSummary(companyId));
    } catch (err) {
      setError('No se pudo cargar el resumen de provisiones');
    } finally {
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => { load(); }, [load]);

  return { data, loading, error, reload: load };
}

// ── Balance de un empleado ──────────────────────────────────────
export function useEmployeeProvisions(employeeId, companyId) {
  const [balance, setBalance]   = useState([]);
  const [history, setHistory]   = useState([]);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);

  const load = useCallback(async () => {
    if (!employeeId || !companyId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await provisionsAPI.getByEmployee(employeeId, companyId);
      setBalance(res.balance || []);
      setHistory(res.history || []);
    } catch (err) {
      setError('No se pudo cargar las provisiones del empleado');
    } finally {
      setLoading(false);
    }
  }, [employeeId, companyId]);

  useEffect(() => { load(); }, [load]);

  return { balance, history, loading, error, reload: load };
}

// ── Provisiones de una nómina ───────────────────────────────────
export function usePayrollProvisions(payrollId) {
  const [detalle, setDetalle]   = useState([]);
  const [resumen, setResumen]   = useState([]);
  const [loading, setLoading]   = useState(false);
  const [error, setError]       = useState(null);

  const load = useCallback(async () => {
    if (!payrollId) return;
    setLoading(true);
    setError(null);
    try {
      const res = await provisionsAPI.getByPayroll(payrollId);
      setDetalle(res.detalle || []);
      setResumen(res.resumen || []);
    } catch (err) {
      setError('No se pudo cargar las provisiones de la nómina');
    } finally {
      setLoading(false);
    }
  }, [payrollId]);

  useEffect(() => { load(); }, [load]);

  return { detalle, resumen, loading, error, reload: load };
}
